"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledButton = _interopRequireWildcard(require("./StyledButton"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["prefixCls", "type", "disabled", "className", "size", "children", "htmlType", "onFocus", "onBlur", "loading", "ghost", "onClick", "icon", "link", "prefix", "suffix"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * YKB UI button.
 */
var InternalButton = function InternalButton(_ref, ref) {
  var prefixCls = _ref.prefixCls,
    type = _ref.type,
    disabled = _ref.disabled,
    className = _ref.className,
    size = _ref.size,
    children = _ref.children,
    htmlType = _ref.htmlType,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    loading = _ref.loading,
    ghost = _ref.ghost,
    onClick = _ref.onClick,
    icon = _ref.icon,
    link = _ref.link,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    others = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    tabfocused = _useState2[0],
    setTabfocused = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  (0, _react.useEffect)(function () {
    return function () {
      document.removeEventListener('keyup', listenTabKeyUp);
    };
  }, []);
  var handleBlur = function handleBlur(e) {
    document.removeEventListener('keyup', listenTabKeyUp);
    setFocused(false);
    setTabfocused(false);
    if (onBlur) {
      onBlur(e);
    }
  };
  var handleFocus = function handleFocus(e) {
    document.addEventListener('keyup', listenTabKeyUp);
    setFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  };
  var handleLinkClick = function handleLinkClick(e) {
    if (disabled || loading) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };
  var listenTabKeyUp = (0, _react.useCallback)(function (e) {
    var code = e.keyCode ? e.keyCode : e.which;
    if (code === 9) {
      setTabfocused(true);
    }
  }, []);
  var isIconOnly = icon && !children || (prefix || suffix) && !(prefix && suffix) && !children || _react.default.Children.count(children) === 1 && /*#__PURE__*/_react.default.isValidElement(children) && children.type === _Icon.default;
  if (typeof link === 'string') {
    return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
      return /*#__PURE__*/_react.default.createElement(_StyledButton.Link, (0, _extends2.default)({
        className: className,
        theme: theme,
        tabfocus: tabfocused,
        colorType: type,
        type: type || !link,
        size: size,
        $loading: loading,
        hasIcon: loading || icon,
        isIconOnly: isIconOnly,
        link: link,
        disabled: disabled || loading,
        onClick: handleLinkClick,
        onFocus: onFocus || handleFocus,
        onBlur: onBlur || handleBlur,
        href: link,
        ref: ref
      }, others), children);
    });
  }
  var iconElement = icon || loading ? /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: loading ? 'spin' : icon
  })) : null;
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledButton.default, (0, _extends2.default)({}, others, {
      type: htmlType,
      className: (0, _classnames.default)(className, (0, _defineProperty2.default)({}, "table-xs", size === 'xsmall'), {
        'icon-only': isIconOnly
      }),
      theme: theme,
      tabfocus: tabfocused,
      colorType: type,
      size: size,
      $loading: loading,
      hasIcon: loading || icon,
      isIconOnly: isIconOnly,
      link: link,
      disabled: disabled || loading,
      onClick: onClick,
      onFocus: handleFocus,
      onBlur: handleBlur,
      prefix: prefix,
      suffix: suffix,
      ref: ref
    }), prefix ? prefix : iconElement, children && /*#__PURE__*/_react.default.createElement(_StyledButton.StyledButtonContent, {
      className: "text"
    }, children), suffix);
  });
};
var Button = /*#__PURE__*/(0, _react.forwardRef)(InternalButton);
Button.propTypes = {
  prefixCls: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  style: _propTypes.default.object,
  type: _propTypes.default.oneOf(['primary', 'secondary', 'default', 'success', 'disabled', 'danger', 'ghost']),
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  htmlType: _propTypes.default.oneOf(['submit', 'button', 'reset']),
  loading: _propTypes.default.bool,
  icon: _propTypes.default.string,
  onClick: _propTypes.default.func,
  /**
   * Default HTML Anchor
   */
  link: _propTypes.default.string
};
Button.defaultProps = {
  prefixCls: 'ykb-ui-button',
  size: 'medium',
  type: 'default',
  disabled: false,
  className: '',
  htmlType: 'button',
  loading: false,
  icon: '',
  onClick: function onClick(noop) {
    return noop;
  }
  // link: undefined,
};
Button.displayName = 'Button';
var _default = exports.default = Button;